<template>
  <div>
    <div class="card card-custom gutter-b">
      <!--begin::Header-->
      <div class="card-header border-0 py-5">
        <h3 class="card-title align-items-start flex-column">
          <span class="card-label font-weight-bolder text-dark">{{
            $t("lastView.cardTitle")
          }}</span>
          <span class="text-muted mt-3 font-weight-bold font-size-sm">{{
            $t("lastView.cardSubtitle")
          }}</span>
        </h3>
      </div>
      <!--end::Header-->

      <!--begin::Body-->
      <div class="card-body py-0">
        <!--begin::Table-->
        <div class="table-responsive">
          <table
            class="table table-head-custom table-vertical-center"
            id="kt_advance_table_widget_2"
          >
            <thead class="text-center">
              <tr class="text-uppercase">
                <th class="pl-0" style="min-width: 100px">
                  {{ $t("lastView.tableHeaders.page") }}
                </th>
                <th style="min-width: 120px">
                  {{ $t("lastView.tableHeaders.address") }}
                </th>
                <th style="min-width: 150px">
                  {{ $t("lastView.tableHeaders.enterDate") }}
                </th>
                <th style="min-width: 150px">
                  {{ $t("lastView.tableHeaders.leaveDate") }}
                </th>
                <th style="min-width: 130px">
                  {{ $t("lastView.tableHeaders.timeSpent") }}
                </th>
              </tr>
            </thead>
            <tbody class="text-center">
              <tr v-for="(item, index) in translatedLogs" :key="index">
                <td class="pl-0">
                  <a
                    href="#"
                    class="text-dark-75 font-weight-bolder text-hover-primary font-size-lg"
                    >{{ item.page }}</a
                  >
                </td>
                <td>
                  <span
                    class="text-dark-75 font-weight-bolder d-block font-size-lg"
                    >{{ item.address }}</span
                  >
                </td>
                <td>
                  <span
                    class="text-dark-75 font-weight-bolder d-block font-size-lg"
                    >{{ item.enterDate }}</span
                  >
                </td>
                <td>
                  <span
                    class="text-dark-75 font-weight-bolder d-block font-size-lg"
                    >{{ item.leaveDate }}</span
                  >
                </td>
                <td>
                  <span class="label label-lg label-light-primary label-inline">
                    {{ item.timeSpent }} {{ $t("lastView.timeUnit") }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="row my-2">
          <div class="col-md-12 text-left left float-left align-left d-flex">
            <button class="btn btn-link-info text-hover-primary">
              <i class="fa fa-arrow-alt-circle-right"></i>
              {{ $t("lastView.viewAll") }}
            </button>
          </div>
        </div>
        <!--end::Table-->
      </div>
      <!--end::Body-->
    </div>
  </div>
</template>

<script>
import i18n from "@/i18n";

export default {
  name: "LastView",
    i18n, 
  data() {
    return {
      logs: [
        {
          pageKey: "home",
          address: "/home",
          enterDate: "1401-12-01 21:33:15",
          leaveDate: "1401-12-01 21:45:15",
          timeSpent: "15",
        },
        {
          pageKey: "panels",
          address: "/panels",
          enterDate: "1401-12-01 21:45:15",
          leaveDate: "1401-12-01 21:50:15",
          timeSpent: "5",
        },
        {
          pageKey: "profile",
          address: "/profile/my-profile",
          enterDate: "1401-12-01 21:50:15",
          leaveDate: "1401-12-01 22:00:00",
          timeSpent: "10",
        },
      ],
    };
  },
  computed: {
    translatedLogs() {
      return this.logs.map((log) => ({
        ...log,
        page: this.$t(`lastView.pages.${log.pageKey}`),
      }));
    },
  },
};
</script>

<style scoped></style>
